import { render, staticRenderFns } from "./NotepadPanel.vue?vue&type=template&id=4a574cf2&scoped=true"
import script from "./NotepadPanel.vue?vue&type=script&lang=js"
export * from "./NotepadPanel.vue?vue&type=script&lang=js"
import style0 from "./NotepadPanel.vue?vue&type=style&index=0&id=4a574cf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a574cf2",
  null
  
)

export default component.exports